import FullBlogPost from 'components/blog/FullBlogPost'
import GoogleTagManagerAttributes from 'components/core/GoogleTagManagerAttributes'
import Footer from 'components/layout/Footer'
import PreviewNotice from 'components/layout/PreviewNotice'
import HeaderContainer from 'components/renderers/HeaderContainer'
import Env from 'Env'
import { TopPosterModel } from 'models/body/TopPosterModel'
import { BlogPostModel } from 'models/core/BlogPostModel'
import { MenuModel } from 'models/menu/MenuModel'
import { GetStaticPaths, GetStaticProps, NextPage } from 'next'
import Head from 'next/head'
import React, { Fragment } from 'react'
import { ApiPromise } from 'services/ApiPromise'
import { Converters } from 'services/Converters'
import { useRouter } from 'next/router'
import ErrorPage from 'next/error'

type PostPath = {
  params: { slug: string }
}

type Props = {
  menu: MenuModel
  footer: MenuModel
  blogPost: BlogPostModel['data']
  isPreview: boolean
  posters: {
    data: TopPosterModel[]
  }
}

const SinglePost: NextPage<Props> = (props) => {
  const router = useRouter()
  if (!router.isFallback && !props.blogPost) {
    return <ErrorPage statusCode={404} />
  }

  return (
    <Fragment>
      <GoogleTagManagerAttributes />
      <Head>
        <title>{props.blogPost.attributes.title}</title>
        <meta name="description" content={props.blogPost.attributes.shortDescription} />
      </Head>
      {props.isPreview && <PreviewNotice />}

      <HeaderContainer posters={props.posters} menu={props.menu} isStatic={true} />

      <FullBlogPost post={props.blogPost} />
      <Footer data={props.footer} />
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const convert = (input: any) => Converters.KeysConvert.ToLowerCase(input)
  const slug = context.params?.slug as string
  const isPreview = context.preview
  const menuAndFooter = ApiPromise.Layout.GetMainAndFooterMenu()
  const [menuPromise, footerPromise, postersPromise] = await Promise.all(menuAndFooter)
  const [menu, footer, posters] = Converters.KeysConvert.ConvertAllToLower([menuPromise.data, footerPromise.data, postersPromise.data])
  const post = await ApiPromise.Blog.PostBySlug(slug, isPreview).then((resp) => convert(resp.data))
  const blogPost = post.data

  return { props: { menu, footer, blogPost, posters, isPreview: isPreview ? true : false }, revalidate: Env.PropsRevalidateTime }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const convert = (input: any) => Converters.KeysConvert.ToLowerCase(input)
  const posts = await ApiPromise.Blog.Posts().then((resp) => convert(resp.data))
  const blogPosts: BlogPostModel['data'][] = posts['data']
  const pathsRecord: PostPath[] = []
  blogPosts.map((post) => {
    pathsRecord.push({ params: { slug: post.attributes.slug } })
  })

  return { paths: pathsRecord, fallback: false }
}

export default SinglePost
